import Image from 'app/Components/Shared/Image/image';
import React, {Fragment, useState, useEffect} from 'react';
import {Col, Row, Button} from 'reactstrap';
import PopUp from '../../../Shared/Popup/PopUp';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import images from '../images/images';
import './PaymentBoxComponent.scss';
import {gaClickInfoToolTipLinkPrivate, gaPopupBanInfoIsOpenedPrivate} from './../gaReports';
import CustomerPaymentMethod from '../../OwnershipTransferCustomerBlock/Steps/CustomerPaymentMethod';
import checkIcon from '../images/check.svg';
const PaymentBoxComponent = (props) => {
  const {
    type,
    title,
    description,
    image,
    checked,
    number,
    toggleComponent,
    isLastUpdated,
    updateSliceProps,
    customersPaymentList,
    onlyOnePaymentMethod,
    paymentMethods,
    onTitleChange,
    onAccountSelectionChange,
    isSinglePayment,
    isSelectionMode = false,
    onEnterSelectionMode,
    useFlexLayout = true,
  } = props;
  const [animate, setAnimate] = useState(false);
  const [showInfoPopUp, setShowInfoPopUp] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showAccountSelection, setShowAccountSelection] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState([]);

  function getLastFourDigits() {
    if (!number) return null;
    // Extract only digits from the entire string
    const digits = number.replace(/\D/g, '');
    // Return last 4 digits if available
    return digits.length >= 4 ? digits.slice(-4) : null;
  }

  const lastFour = getLastFourDigits();

  // Function to format payment method display based on type
  function getPaymentMethodDisplay() {
    if (type === 'DIFFERENT' || type === 'UNKNOW' || type === 'PAYPAL') {
      return description;
    } else {
      return lastFour ? `${description} | ${lastFour} ****` : `${description} | ****`;
    }
  }

  // Function to get the correct icon based on payment method type
  function getPaymentMethodIcon() {
    switch (type) {
      case 'BANK':
        return images.bank;
      case 'CREDIT_CARD':
        return images.newcreditcard;
      case 'PAYPAL':
        return images.paypal;
      case 'DIFFERENT':
      case 'UNKNOW':
        return images.differentpayment;
      default:
        return images.newcreditcard;
    }
  }

  useEffect(() => {
    if (checked && isLastUpdated) {
      setTimeout(() => setAnimate(true), 300);
    }
  }, []);

  function raisePopUpInfo(type) {
    gaClickInfoToolTipLinkPrivate(paymentMethods[type]);
    gaPopupBanInfoIsOpenedPrivate();
    setShowInfoPopUp(true);
  }

  function closePopUp() {
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
    setShowInfoPopUp(false);
  }

  function drawInfoAccounts() {
    const products = customersPaymentList.map(function (elem, i) {
      return (
        <div key={i} className='d-flex flex-column' style={{color: '#4a4a4a', marginBottom: '15px'}}>
          <div>חשבון {elem.id}</div>
          <div>{elem.name}</div>
        </div>
      );
    });
    return products;
  }

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const toggleAccountSelection = () => {
    // In view mode, entering selection mode should be handled by parent
    if (!isSelectionMode && onEnterSelectionMode) {
      onEnterSelectionMode();
      // Immediately show account selection for this card
      setShowAccountSelection(true);
      setIsExpanded(true);

      // Auto-select all accounts
      if (customersPaymentList) {
        const allAccountsIds = customersPaymentList.map((account) => account.id);
        setSelectedAccounts(allAccountsIds);

        if (onAccountSelectionChange) {
          onAccountSelectionChange(allAccountsIds, type);
        }
      }

      if (onTitleChange) {
        onTitleChange('החשבונות שיעודכנו');
      }
      return;
    }

    // In selection mode, handle account selection as before
    const newState = !showAccountSelection;
    setShowAccountSelection(newState);

    // Auto-expand when entering selection mode, collapse when exiting
    if (newState) {
      setIsExpanded(true);
    } else {
      setIsExpanded(false);
    }

    if (newState && customersPaymentList) {
      const allAccountsIds = customersPaymentList.map((account) => account.id);
      setSelectedAccounts(allAccountsIds);

      if (onAccountSelectionChange) {
        onAccountSelectionChange(allAccountsIds, type);
      }
    } else {
      setSelectedAccounts([]);
      if (onAccountSelectionChange) {
        onAccountSelectionChange([], type);
      }
    }

    if (onTitleChange) {
      onTitleChange(newState ? 'חשבונות לעדכון' : 'אמצעי התשלום שלך');
    }
  };

  const handleAccountCheck = (accountId, isChecked) => {
    let newSelectedAccounts;
    if (isChecked) {
      newSelectedAccounts = [...selectedAccounts, accountId];
    } else {
      newSelectedAccounts = selectedAccounts.filter((id) => id !== accountId);
    }
    setSelectedAccounts(newSelectedAccounts);

    if (onAccountSelectionChange) {
      onAccountSelectionChange(newSelectedAccounts, type);
    }
  };

  const getSelectedAccountsData = () => {
    return selectedAccounts;
  };

  return (
    <div className={`payment-box-card ${checked ? 'payment-box-card--checked' : ''}`}>
      <div className='payment-box-card__content'>
        <div className='payment-box-card__header'>
          {!isSinglePayment && !(isSelectionMode && showAccountSelection) && (
            <div className='payment-box-card__checkbox'>
                <Button
                  color='link'
                  className={`btn btn-as-checkbox ${checked ? 'checked' : ''}`}
                  onClick={() => toggleComponent(type)}>
                  {checked && (
                   <Image src={checkIcon} alt='check' />
                  )}
                </Button>
            </div>
          )}
          <div className={`payment-box-card__main-info ${useFlexLayout ? 'with-flex' : 'without-flex'}`}>
            <div className={`payment-box-card__icon ${!useFlexLayout ? 'large-icon' : ''}`}>
              <Image src={getPaymentMethodIcon()} alt={description || 'שגיאה'} />
            </div>
            <div className='payment-box-card__payment-details'>
              <div className='payment-box-card__description'>{getPaymentMethodDisplay()}</div>
              <div className='payment-box-card__number'></div>
            </div>
          </div>
          {isSinglePayment && !(isSelectionMode && showAccountSelection) && (
            <div className='payment-box-card__update-btn'>
              <Button
                className={`update-button ${animate ? 'animateBounce' : ''} ${checked ? 'bold' : ''}`}
                onClick={toggleAccountSelection}>
                עדכון
              </Button>
            </div>
          )}
        </div>

        <div className='payment-box-card__footer'>
          <div
            className={`payment-box-card__expandable-trigger ${isSelectionMode && showAccountSelection ? 'disabled' : ''}`}
            onClick={isSelectionMode && showAccountSelection ? null : toggleExpanded}>
            <span className='payment-box-card__expand-text'>{`מוגדר ב-${customersPaymentList.length} חשבונות`}</span>
            <span className={`payment-box-card__chevron ${isExpanded ? 'expanded' : ''}`}>
              {isExpanded ? (
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'>
                  <path
                    d='M12.456 11.2399C12.8332 11.6114 13.417 11.5813 13.7599 11.1727C14.0765 10.7954 14.0772 10.2275 13.7787 9.8502L13.6978 9.76005L8.62093 4.76006C8.29819 4.44221 7.81948 4.41572 7.47074 4.6806L7.37907 4.76006L2.30215 9.76005C1.92493 10.1316 1.89713 10.764 2.24006 11.1727C2.55661 11.5499 3.0784 11.6046 3.4535 11.3185L3.54401 11.2399L7.99908 6.851L12.456 11.2399Z'
                    fill='black'
                  />
                </svg>
              ) : (
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'>
                  <path
                    d='M12.456 5.76007C12.8332 5.38856 13.417 5.41868 13.7599 5.82733C14.0765 6.20456 14.0772 6.77246 13.7787 7.1498L13.6978 7.23995L8.62093 12.2399C8.29819 12.5578 7.81948 12.5843 7.47074 12.3194L7.37907 12.2399L2.30215 7.23995C1.92493 6.86844 1.89713 6.23599 2.24006 5.82733C2.55661 5.45011 3.0784 5.39543 3.4535 5.68145L3.54401 5.76007L7.99908 10.149L12.456 5.76007Z'
                    fill='black'
                  />
                </svg>
              )}
            </span>
          </div>

          {isExpanded && (
            <div className='payment-box-card__expanded-content'>
              {isSelectionMode && showAccountSelection ? (
                <div className='payment-box-card__account-selection'>
                  {customersPaymentList && customersPaymentList.length > 0 && (
                    <div className='selectable-accounts-list'>
                      {customersPaymentList.map((account, index) => (
                        <div key={index} className='selectable-account-item'>
                          <div className='account-checkbox'>
                            <input
                              type='checkbox'
                              id={`account-${index}`}
                              checked={selectedAccounts.includes(account.id)}
                              onChange={(e) => handleAccountCheck(account.id, e.target.checked)}
                            />
                            {selectedAccounts.includes(account.id) && (
                              <Image src={checkIcon} alt='check' className='account-checkbox__check' />
                            )}
                          </div>
                          <div className='account-details'>
                            <div className='account-number'>חשבון {account.id}</div>
                            <div className='account-name'>{account.name}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                customersPaymentList &&
                customersPaymentList.length > 0 && (
                  <div className='payment-box-card__accounts-list'>
                    {customersPaymentList.map((account, index) => (
                      <div key={index} className='payment-box-card__account-item'>
                        <div className='account-number'>חשבון {account.id}</div>
                        <div className='account-name'>{account.name}</div>
                      </div>
                    ))}
                  </div>
                )
              )}
            </div>
          )}

          {!updateSliceProps.data.isBusinessBlock && (type === 'DIFFERENT' || type === 'UNKNOW') && (
            <div className='payment-box-card__warning'>
              <Image src={images.warning} className='warning-icon' />
              עדכנו כדי למנוע חוב
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentBoxComponent;
